import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  withStyles,
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles';
import { withRouter, Redirect } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { getMarket, getIsDataDirty } from '../../features/app/selectors';
import { setMarket } from '../../features/app/actions';
import { getUserMarkets } from '../../features/loginSystem/selectors';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';
import { alert, close as closeAlert } from '../../features/alertSystem/actions';

import useMarketLabel from 'features/app/hooks/useMarketLabel';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import { sortBy } from 'lodash';

const styles = theme => ({
  root: {
    minWidth: '9rem',
    color: 'white'
  },
  text: {
    color: theme.palette.primary.contrastText
  }
});

const inputProps = {
  name: 'market',
  id: 'market-menu'
};

const muiTheme = createMuiTheme({
  palette: {
    type: 'dark',
    background: {
      paper: '#0058a3'
    }
  }
});

function MarketMenu({
  userMarkets = [],
  isDataDirty,
  market,
  setMarketEvent,
  history,
  intl,
  classes,
  alert,
  closeAlert
}) {
  const [isFetchingMarket, marketNames, fetchNameError] = useMarketLabel();

  const onMarketChanged = event => {
    const newMarket = userMarkets.find(
      marketObj => marketObj.market === event.target.value
    );

    if (isDataDirty) {
      alert({
        title: intl.formatMessage({ id: 'appBar.confirmLeaveTitle' }),
        content: intl.formatMessage({ id: 'appBar.confirmLeaveMessage' }),
        actions: {
          right: [
            <Button
              key="stay"
              onClick={() => {
                closeAlert();
              }}
              color="primary"
            >
              <FormattedMessage id="appBar.confirmStayOnPageButtonText" />
            </Button>,
            <Button
              key="leave"
              onClick={() => {
                closeAlert();
                setMarketEvent({ market: newMarket, refetch: true });
                history.push('/');
                window.location.reload();
              }}
              color="secondary"
            >
              <FormattedMessage id="appBar.confirmLeaveButtomText" />
            </Button>
          ]
        }
      });
    } else {
      setMarketEvent({ market: newMarket, refetch: true });
      history.push('/');
      window.location.reload();
    }
  };

  if (isFetchingMarket) {
    return <ProgressFullscreen open />;
  }

  // if (userMarkets.length > 1) {
  //   console.warn(
  //     'Unsupported use-case that user is connected to multiple markets. Need to be implemented.'
  //   );
  // }

  if (userMarkets.length === 0) {
    return null;
  }

  function createMarketDisplayLabel(data) {
    const result = {};
    data.forEach(i => {
      result[i.countryCode] = i.displayLabel;
    });
    return result;
  }

  if (fetchNameError) {
    throw fetchNameError;
  }

  const marketLabelToDisplay = createMarketDisplayLabel(marketNames);
  // const sortedMarkets = userMarkets.sort((a, b) =>
  //   marketLabelToDisplay[a.market].localeCompare(marketLabelToDisplay[b.market])
  // );
  const sortedMarkets = sortBy(
    userMarkets,
    market => marketLabelToDisplay[market.market]
  );
  // console.log("before", market)
  //   const cmarket = userMarkets[0].market;
  //   console.log("after", cmarket)
  // return (
  //   <Typography color="inherit">
  //     <FormattedMessage id={`internationalization.${market}`} />
  //   </Typography>
  // );

  return (
    <MuiThemeProvider theme={muiTheme}>
      <FormControl className={classes.root} margin="dense">
        <InputLabel htmlFor="market-menu">
          <FormattedMessage id="appBar.marketSelectorDesc" />
        </InputLabel>
        <Select
          value={market.market}
          onChange={onMarketChanged}
          inputProps={inputProps}
        >
          {sortedMarkets.map(marketObj => {
            return (
              <MenuItem key={marketObj.market} value={marketObj.market}>
                {marketLabelToDisplay[marketObj.market]}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </MuiThemeProvider>
  );
}

MarketMenu.propTypes = {
  userMarkets: PropTypes.array.isRequired,
  market: PropTypes.object.isRequired,
  isDataDirty: PropTypes.bool.isRequired,
  setMarketEvent: PropTypes.func.isRequired,
  alert: PropTypes.func.isRequired,
  closeAlert: PropTypes.func.isRequired
};

MarketMenu.defaultProps = {
  isGlobalUser: null
};

export default connect(
  state => ({
    userMarkets: getUserMarkets(state),
    market: getMarket(state),
    isDataDirty: getIsDataDirty(state)
  }),
  {
    setMarketEvent: setMarket,
    alert,
    closeAlert
  }
)(ImmutablePropsToJS(withRouter(withStyles(styles)(MarketMenu))));
